<template>
  <div class="agent-details-update">
    <div class="form-group" v-if="agent">
      <h2 class="ut-text-left ut-ml-0 subtitle">Your details</h2>
      <BannerInfo text="Please note your email address will be used as your account username"/>
      <div class="md:ut-flex ut-content-start ut-items-top ut-flex-wrap">
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pr-2 ut-w-full md:ut-w-1/2">
          <text-input
                :label="form.agentName.label"
                :isMandatory="true"
                :type="Types.Input.Text"
                :default="agent.name"
                @validated-fields="validate"
                @input="onInput"
              />
        </div>
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pl-2 ut-w-full md:ut-w-1/2">
          <text-input
              :label="form.agentEmail.label"
              :isMandatory="true"
              :type="Types.Input.Email"
              :default="agent.email"
              @validated-fields="validate"
              @input="onInput"
            />
        </div>
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pr-2 ut-w-full md:ut-w-1/2">
          <text-input
              :label="form.agentPhone.label"
              :isMandatory="true"
              :type="Types.Input.Phone"
              :default="agent.phone"
              @validated-fields="validate"
              @input="onInput"
            />
        </div>
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pl-2 ut-w-full md:ut-w-1/2 ut-relative">

          <span class="ut-rounded-full ut-w-5 ut-h-5 ut-border ut-mx-2
            ut-text-center ut-cursor-pointer ut-absolute ut-left-0 ut-ml-56 ut-leading-none"
            v-tooltip="recoveryEmailToolTip">i</span>
          <text-input
              :label="form.agentPersonalEmail.label"
              :type="Types.Input.Email"
              :default="agent.personalemail"
              @validated-fields="validate"
              @input="onInput"
            />
        </div>
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pr-2 ut-w-full md:ut-w-1/2">
          <agency-search-input
              :label="form.currentAgency.label"
              :default="currentAgency"
              @validated-fields="validate"
              @input="onInput"
            />
        </div>
      </div>
      <div>
        <label>Update photo</label>
        <p class="ut-my-2 ut-italic">Please send a request to the Agent Support team at
          <a class="ut-text-green-400" href="mailto:agentsupport@openagent.com.au">
            agentsupport@openagent.com.au</a>,
          along with your new photo.</p>
        <!-- <file-input
        class = "subsection"
        :label="form.agentPhoto.label"
        :placeholder="form.agentPhoto.placeholder"
        :isMandatory="false"
        @file-uploading="fileUploading"
        @validated-fields="validate"
        @input="onFileInput"
      /> -->
      </div>
      <div class="ut-flex ut-justify-start ut-items-center">
        <h2 class="ut-text-left ut-mx-0 subtitle">Secondary contact details</h2>
        <span class="ut-rounded-full ut-w-5 ut-h-5 ut-border ut-mx-2
          ut-text-center ut-cursor-pointer ut-leading-none"
            v-tooltip="secondaryContactDetailsToolTip">i</span>
      </div>
      <div class="md:ut-flex ut-content-start ut-items-top ut-flex-wrap">
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pr-2 ut-w-full md:ut-w-1/2">
          <text-input
              :label="form.assistantEmail.label"
              :type="Types.Input.Email"
              :default="agent.secondaryemail"
              @validated-fields="validate"
              @input="onInput"
            />
        </div>
        <div class="ut-m-0 ut-p-0 ut-pb-4 md:ut-pl-2 ut-w-full md:ut-w-1/2">
          <text-input
            :label="form.assistantName.label"
            :type="Types.Input.Text"
            :default="agent.secondaryname"
            @validated-fields="validate"
            @input="onInput"
          />
        </div>
      </div>
      <oa-button
        :text="'Save'"
        :btnClass="{ color: 'green' }"
        :disabled="disableSubmit"
        @click="clickedValidate"
        v-gaEvent="gaEvent('Agent Personal Details - Validate edit')"
      />
      <oa-button
        :text="'Cancel'"
        :btnClass="{ color: 'white', margin: 'left' }"
        @click="cancelEdit"
        v-gaEvent="gaEvent('Agent Personal Details - Cancel edit')"
      />
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import OaButton from '@/components/Forms/OaButton.vue';
import AgencySearchInput from '@/components/Forms/AgencySearchInput.vue';
import TextInput from '@/components/Forms/TextInput.vue';
import FormHandler from '@/mixins/FormHandler';
import Types from '@/Mapper/CustomType';
import BannerInfo from '@/components/BannerInfo.vue';
// import FileInput from '@/components/Forms/FileInput.vue';
import FileUpload from '@/mixins/FileUpload';

export default {
  name: 'AccountContactDetailsUpdate',
  mixins: [
    FormHandler,
    FileUpload,
  ],
  components: {
    OaButton,
    AgencySearchInput,
    TextInput,
    BannerInfo,
    // FileInput,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    currentAgency() {
      return this.agent && this.agent.agencyname
        ? { fullname: this.agent.agencyname, id: this.agent.agencyid }
        : {};
    },
  },
  data() {
    return {
      disableSubmit: false,
      Types,
      uploadedFiles: [],
      secondaryContactDetailsToolTip: {
        content: `This is a second contact. For example your assistant or another agent who works with you.
          <br><br>This contact will also receive the weekly OpenAgent Open Leads Digest.`,
        classes: ['info'],
        trigger: 'hover click',
      },
      recoveryEmailToolTip: {
        content: `This is an email address where we can send your password reset link if you no longer
          have access to your primary email account (e.g. if you change agencies)
          <br><br>We will never send any other emails to this email address.`,
        classes: ['info'],
        trigger: 'hover click',
      },
      form: {
        agentName: {
          label: 'Name',
          values: {},
        },
        agentPhone: {
          label: 'Phone number',
          values: {},
        },
        agentEmail: {
          label: 'Email address',
          values: {},
        },
        agentPersonalEmail: {
          label: 'Personal / recovery email address',
          values: {},
        },
        // agentPhoto: {
        //   label: 'Update photo',
        //   placeholder: 'Drop your photo here, up to 10MB',
        //   values: {},
        // },
        assistantName: {
          label: 'Secondary name',
          values: {},
        },
        assistantEmail: {
          label: 'Secondary email address',
          values: {},
        },
        currentAgency: {
          label: 'Agency',
          values: {},
        },
      },
    };
  },
  methods: {
    saveDetails() {
      const data = {
        agentid: this.agent.id,
        agentname: this.form.agentName.values.value,
        agentphone: this.form.agentPhone.values.value,
        agentemail: this.form.agentEmail.values.value,
        agentpersonalemail: this.form.agentPersonalEmail.values.value,
        agentagencyid: this.form.currentAgency.values.select.id,
        agencyname: this.form.currentAgency.values.select.fullname,
        agentdigest: this.agent.hasagentdigest,
        secondaryname: this.form.assistantName.values.value,
        agentsecondaryemail: this.form.assistantEmail.values.value,
        eventsource: 'Agent Portal',
        oauserid: this.agent.userid,
        platformtypeid: 3,
        formname: 'edit-agent-form',
      };

      this.$apiServices.oa.agent.update(data)
        .then(() => {
          this.$store.dispatch('agentStore/loadAgent', this.agent.key)
            .then(() => {
              this.cancelEdit();
            });
        });
    },
    gaEvent(eventAction, eventLabel) {
      const label = `AID=${this.agent.id}${eventLabel ? ` | ${eventLabel}` : ''}`;
      return {
        category: 'AgentPortal',
        action: eventAction,
        label,
      };
    },
    onFileInput(values) {
      this.disableSubmit = false;
      this.uploadedFiles = values.value;
      this.onInput(values);
    },
    cancelEdit() {
      this.$emit('cancel-edit-details');
    },
  },
};

</script>

<style lang="scss" scoped>
.subtitle {
  @apply ut-text-lg ut-font-bold ut-my-4;
  letter-spacing: -0.2px;
  line-height: 25px;
}

.form-group input {
  @apply ut-mb-3;

  &.error {
    @apply ut-mb-0;
  }
}
</style>
